export default __webpack_public_path__ + "static/media/invoice-icon.09a3bf40.jpeg";